import * as React from 'react';
import { useDispatch } from 'react-redux';

import { trackActionButtonClick } from './tracking';
import { sendWsAnswer } from '../../actions/wsAnswer';
import { Promo, Socket } from '../../components/ActionButton';
import { EActionButtonType, TActionButton } from '../../types/actionButton';
import { doesButtonHaveDailyrentReviewLink } from '../../utils/dailyrent/shouldShowDailyrentReviewButtons';
import { useDailyrentReviewModal } from '../../utils/dailyrent/useDailyrentReviewModal';
import { DemandActionContainer } from '../DemandActionContainer';

type TActionButtonContainerProps = {
  actionButton: TActionButton;
  messageId: string;
};

const DEMAND_TRAP_LINK = 'homeownerLeadCreateMessage';

export const ActionButtonContainer: React.VFC<TActionButtonContainerProps> = ({ actionButton, messageId }) => {
  const { link, promoName, type, text, socketPayload } = actionButton;

  const dispatch = useDispatch();

  const isDailyrentSuccessReviewButton = doesButtonHaveDailyrentReviewLink(actionButton);
  const { openModal } = useDailyrentReviewModal();

  const handlePromoClick = React.useCallback(() => {
    if (promoName) {
      trackActionButtonClick(promoName);
    }
  }, [promoName]);

  const handleDailyrentButton = React.useCallback(
    (evt: React.MouseEvent<HTMLAnchorElement>) => {
      evt.preventDefault();
      openModal();
      if (promoName) {
        trackActionButtonClick(promoName);
      }
    },
    [openModal, promoName],
  );

  const handleSocketClick = React.useCallback(() => {
    dispatch(sendWsAnswer({ messageId, payload: socketPayload as string }));
  }, [dispatch, messageId, socketPayload]);

  if (link === DEMAND_TRAP_LINK) {
    return <DemandActionContainer actionButton={actionButton} />;
  }

  if (isDailyrentSuccessReviewButton) {
    return <Promo link={link as string} text={text} onClick={handleDailyrentButton} />;
  }

  if (type === EActionButtonType.Socket) {
    return <Socket text={text} onClick={handleSocketClick} />;
  }

  if (link) {
    return <Promo link={link as string} text={text} onClick={handlePromoClick} />;
  }

  return null;
};
